import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/unit/Layout';


import HomePage from './pages/spage/home/HomePage';
import AboutPage from './pages/spage/other/AboutPage';
import NotFoundPage from './pages/spage/error/NotFoundPage';

import Design from './pages/spage/products/software/design/design';
import DLNAPage from './pages/spage/products/software/DLNA/DLNAPage';


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/:category/:productId" element={<HomePage />} /> */}
          {/* <Route path="/about" element={<AboutPage />} /> */}
          {/* 软件产品 */}
          <Route path="/products/software/dlna" element={<DLNAPage />} />
          {/* <Route path="/products/software/design" element={<Design />} /> */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;